export default countries => countries
  .filter(country =>
    country.unLocationList && country.unLocationList.length)
  .map((country) => {
    const childrenUnlocode = country.unLocationList
      .map(unlocode =>
        ({
          value: unlocode.code,
          label: unlocode.nameWithoutSpecialChars ?
            `${unlocode.code.substring(unlocode.code.length - 3)} - ${unlocode.nameWithoutSpecialChars}` :
            unlocode.code.substring(unlocode.code.length - 3),
        }));
    return {
      value: country.countryCode,
      label: country.countryName ? `${country.countryCode} - ${country.countryName}` : country.countryCode,
      children: childrenUnlocode,
    };
  });
